import { EntityDiagramActionFn, OpenSummaryPanelAction } from '../types';

export const openSummaryPanelAction: EntityDiagramActionFn<
  OpenSummaryPanelAction
> = (state, { nodeId }, _queueEffect) => {
  return { ...state, summaryNodeId: nodeId, highlightedIds: new Set() };
};
